import themes from 'common/theme'
import styled from 'styled-components'

const Modal = styled.div`
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: ${themes.zIndex.modal};
`

const setStyle = ({ anchor, height, width }: content): string => {
  switch (anchor) {
    case 'left':
    default:
      return `
        max-width: ${width || '570px'};
        height: ${height || '100vh'};
        bottom: 0;
        left: 0;
        right: auto;
      `
    case 'right':
      return `
        max-width: ${width || '570px'};
        height: ${height || '100vh'};
        bottom: 0;
        right: 0;
        left: auto;
      `
    case 'top':
      return `
        max-width: ${width || '100%'};
        height: ${height || 'auto'};
        max-height: 100%;
        top: 0;
        bottom: auto;
        left: 0;
      `
    case 'bottom':
      return `
        max-width: ${width || '100%'};
        height: ${height || 'auto'};
        max-height: 100%;
        top: auto;
        bottom: 0;
        left: 0;
      `
  }
}

const ModalContent = styled.div<content>`
  position: absolute;
  width: 100%;
  pointer-events: auto;
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-clip: padding-box;
  border-radius: ${themes.radius.base};
  outline: 0;
  ${({ anchor, height, width }: content) =>
    setStyle({ anchor, height, width })}
`

interface drawer {
  children: JSX.Element
  contentProps?: content
  onClose: Function
  open: Boolean
}

interface content {
  anchor?: string
  backgroundColor?: string
  height?: string
  width?: string
}

const defaultContentProps = {
  anchor: 'left',
  backgroundColor: themes.colors.white,
  height: '',
  width: '',
}

function Drawer({
  children,
  contentProps = { ...defaultContentProps },
  onClose,
  open = false,
}: drawer): JSX.Element {
  if (!open) {
    return null
  }
  return (
    <Modal onClick={onClose} data-testid="drawer-component">
      <ModalContent
        {...{ ...defaultContentProps, ...contentProps }}
        onClick={(e) => e.stopPropagation()}
        data-testid="modal-content"
      >
        {children}
      </ModalContent>
    </Modal>
  )
}

export default Drawer
